import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/images/nevcap-logo.svg'


const _hoisted_1 = { class: "bg-white px-4 py-2.5 dark:bg-gray-800 border-b border-gray-300" }
const _hoisted_2 = { class: "flex items-center justify-between max-w-screen-lg mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-between lg:order-2"
}
const _hoisted_4 = { class: "flex items-center justify-between p-1 mt-2 bg-black border rounded-full hover:bg-gray-900 min-w-48" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "ml-2 mr-4 text-xs font-bold text-white" }
const _hoisted_7 = { class: "px-5 py-3 -m-2 bg-black rounded-t-lg dark:bg-gray-700" }
const _hoisted_8 = { class: "text-sm font-medium text-white dark:text-gray-300" }
const _hoisted_9 = { class: "py-2 mt-2 first:pt-0 last:pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_AdministratorNavbar = _resolveComponent("AdministratorNavbar")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex items-center justify-start" }, [
          _createElementVNode("a", {
            class: "flex mr-6",
            href: "/"
          }, [
            _createElementVNode("img", {
              alt: "Nevcap Logo",
              class: "mr-3 ml-1.5 h-8 sm:h-8",
              src: _imports_0
            })
          ]),
          _createElementVNode("form", {
            action: "#",
            class: "hidden md:block lg:pl-2",
            method: "GET"
          }, [
            _createElementVNode("label", {
              class: "sr-only",
              for: "topbar-search"
            }, "Search"),
            _createElementVNode("div", { class: "relative md:w-64 lg:w-96" }, [
              _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
                _createElementVNode("svg", {
                  class: "w-5 h-5 text-gray-500 dark:text-gray-400",
                  fill: "currentColor",
                  viewBox: "0 0 20 20",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "clip-rule": "evenodd",
                    d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
                    "fill-rule": "evenodd"
                  })
                ])
              ]),
              _createElementVNode("input", {
                id: "topbar-search",
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500",
                name: "search",
                placeholder: "Search courses, users, modules...",
                type: "text"
              })
            ])
          ])
        ], -1)),
        (_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_DropdownMenu, null, {
                trigger: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex items-center justify-center w-8 h-8 bg-white rounded-full hover:bg-yellow-300" }, [
                        _createElementVNode("span", { class: "text-xs font-bold text-black" }, "SN")
                      ], -1)),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.fullName), 1)
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mr-4" }, [
                      _createElementVNode("svg", {
                        fill: "none",
                        height: "6",
                        viewBox: "0 0 10 6",
                        width: "10",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M1 1L5 5L9 1",
                          stroke: "white",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "1.33333"
                        })
                      ])
                    ], -1))
                  ])
                ]),
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-gray-400 dark:text-gray-400" }, " Signed in as ", -1)),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.user ? _ctx.user.email : ''), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_router_link, {
                      class: "flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-primary dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600",
                      to: "logout"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Sign out ")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_AdministratorNavbar)
  ]))
}